export default function PHP_libxml_clear_errors() {
  return (
    <div>
      <h1>PHP_libxml_clear_errors</h1>
    </div>
  );
}
